import { BaseFormatAdapter } from 'app/model/adapters/dataflow/formatAdapters/base-format.adapter';
import { WorkdaySettings } from 'app/model/dataflow/dataset-settings/workday-settings';
import { DataFlowDSLAdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import XmlBeautify from '../../../dataflow/xml-util';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(WorkdaySettings)
})
export class WorkdayAdapter extends BaseFormatAdapter<WorkdaySettings> {
    public async toSourceDSL(setting: WorkdaySettings): Promise<string[]> {
        const props = [];
        props.push(`store: '${DatasetFormatType.Workday}'`);
        props.push(`format: '${DatasetFormatType.Workday}'`);
        if (setting.request.expression) {
            setting.request.expression = XmlBeautify.minify(setting.request.expression);
            props.push(`request: ${DataFlowExpressionUtils.wrapExpressionConfigValue(setting.request)}`);
        }
        return props;
    }

    public async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<WorkdaySettings> {
        const setting = this._generateSetting(owner);
        if (configs.has('request')) {
            setting.request = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('request'), owner);
            setting.request.expression = XmlBeautify.beautify(setting.request.expression);
            handledConfigs.push('request');
        }
        return setting;
    }

    protected _generateSetting(owner: DataFlowSource | DataFlowSink): WorkdaySettings {
        const setting = Owned.create<WorkdaySettings>(WorkdaySettings.MODEL, owner);
        setting.initialize(undefined);
        return setting;
    }
}
